var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"videocall-button",on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-video"})])
}
var staticRenderFns = []

export { render, staticRenderFns }